export interface IDeviceSettingsState {
  /** The camera device ID. */
  cameraId?: string

  /** The speaker device ID. */
  speakerId?: string

  /** The microphone device ID. */
  microphoneId?: string

  /** Whether we encountered an error when getting the camera ID. */
  failedToGetCameraId?: boolean

  /** Whether to use front or back camera (only applied to mobile device). */
  facingMode: 'user' | 'environment'

  /** Whether to use AEC (echo cancellation) for the microphone. Defaults to true. */
  microphoneAEC: boolean

  /** Whether to use AGC (automatic gain control) for the microphone. Defaults to true. */
  microphoneAGC: boolean

  /** Whether to use ANS (automatic noise suppression) for the microphone. Defaults to true. */
  microphoneANS: boolean
}

/**
 *
 */
export function createDeviceSettingsState(): IDeviceSettingsState {
  return {
    facingMode: 'user',
    microphoneAEC: true,
    microphoneAGC: true,
    microphoneANS: true,
  }
}
